import {Component} from '@angular/core';
import {NavParams, ViewController} from 'ionic-angular';
import {AlertService} from '../../../providers/alert-service';
import {MonitoramentoDecisoesService} from '../../../providers/monitoramento-decisoes-service';
import {FileService} from '../../../providers/file-service';
import {ArquivosService} from "../../../providers/arquivos-service";

@Component({
  selector: 'page-modal-determinacoes-evidencias',
  templateUrl: 'modal-determinacoes-evidencias.html'
})
export class ModalDeterminacoesEvidenciasPage {

  determinacao: any = null;
  listaArquivos: any = [];
  servico: any;
  tiposAceitos: any = "application/pdf, application/xml";
  loading: boolean = true;
  cdModulo: any = "10";

  PCAAtiva: any;
  tipoDocumento: any;
  titulo: any;
  isJurisdicionado: any;
  isCGE: any;
  IdProcesso: any = null;
  idModuloPCA: any = null;
  tipoAnalise: any = null;
  tipoEntidadeExercicio: any = null;
  tipodocumento: any = null;
  listaArquivosPCA: any;
  origemArquivo: any;
  listaPecasProcessuaisObrigatoria: any[];
  origemModal: boolean = false;
  origemFilter: any;
  usuarioLogado: any;

  constructor(private alertService: AlertService,
    private viewCtrl: ViewController,
    private fileService: FileService, public arquivoService: ArquivosService,
    public navParams: NavParams,
    public monitoramentoDecisoesService: MonitoramentoDecisoesService) {
    this.determinacao = this.navParams.get('determinacao');




    this.titulo = this.navParams.get('titulo');
    this.isJurisdicionado = this.navParams.get('jurisdicionado');
    this.isCGE = this.navParams.get('isCGE');
    this.IdProcesso = this.navParams.get('IdProcesso');
    this.idModuloPCA = this.navParams.get('idModuloPCA');
    this.tipoAnalise = this.navParams.get('tipoAnalise');

    this.tipoEntidadeExercicio = this.navParams.get('tipoEntidadeExercicio');
    this.tipodocumento = this.navParams.get('tipodocumento');

    this.origemFilter = this.navParams.get('origemFilter');

    if (this.navParams.get('origemArquivo') != undefined && this.navParams.get('origemArquivo') != null) {
      this.origemArquivo = this.navParams.get('origemArquivo');
    } else {
      this.origemArquivo = 'NA';
    }

    if (this.navParams.get('origemFilter') != undefined) {
      this.origemFilter = this.navParams.get('origemFilter');
    } else {
      this.origemFilter = null;
    }

    this.carregarModal();
  }

  dismiss() {
    this.viewCtrl.dismiss();
  }

  carregarModal() {
    this.listarArquivos();
  }

  listarArquivos() {
    // this.fileService.listarArquivo(this.determinacao.idMonitoramento, this.cdModulo, "0").subscribe(data => {
    this.arquivoService.listarPecasVinculadasPCA(this.IdProcesso, this.idModuloPCA, this.tipoAnalise, false).subscribe(data => {
      this.listaArquivos = data;
      this.loading = false;
    }, error => {
      console.log("erro: " + error);
      this.alertService.mostraAlerta("", "Não foi possível listar os arquivos.");
      this.loading = false;
    });
  }

  baixarArquivo(idArquivo) {
    this.loading = true;
    this.fileService.downloadArquivo(idArquivo);
    this.loading = false;
  }

  fileChange(event) {
    this.alertService.mostraModalConfirmacao("Salvar Arquivo", "Arquivo selecionado, confirma importação?", callback => {
      if (callback) {

        let fileList: FileList = event.target.files;
        if (fileList.length > 0) {
          let file: File = fileList[0];

          if (file.size <= 10485760) {
            // this.monitoramentoDecisoesService.enviarEvidencia(event, this.determinacao.idMonitoramento, this.determinacao.idModuloAnalise).subscribe(data => {
            this.fileService.enviarArquivo(event, this.determinacao.idMonitoramento, this.cdModulo, "10").subscribe(data => {
              this.alertService.mostraAlerta("", "Arquivo importado com sucesso!");
              this.listarArquivos();
            }, error => {
              this.alertService.mostraAlerta("Houve um erro ao carregar arquivo.", error);
              console.log("erro: " + error);
            });
          } else {
            this.alertService.mostraAlerta("", "Arquivo ultrapassou o limite de tamanho de 10Mb.");
          }
        }
      }
    });
  }

  deletarArquivo(arquivo) {
    this.alertService.mostraModalConfirmacao("Excluir Arquivo", "Você tem certeza que deseja excluir o arquivo " + arquivo.nmArquivo + "?",
      retornoModal => {
        if (retornoModal) {
          // this.monitoramentoDecisoesService.deletarEvidencia(arquivo.idArquivoVinculado).subscribe(data => {
          this.fileService.deletarArquivo(arquivo.idArquivoVinculado).subscribe(data => {
            this.alertService.mostraAlerta("", "Arquivo excluído com sucesso.");
            this.listarArquivos();
          }, error => {
            console.log("erro: " + error);
            this.alertService.mostraAlerta("", "Houve um erro ao excluir arquivo.");
          });
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/modais/modal-determinacoes-evidencias/modal-determinacoes-evidencias.ts